var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('atom-text',_vm._b({key:_vm.error,staticClass:"ml-1",attrs:{"size":"x-small","color":"danger"}},'atom-text',_vm.$props,false),[_vm._v(" ❗ "+_vm._s(_vm.error)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }